// extracted by extract-css-chunks-webpack-plugin
module.exports = {"conversions":"conversions___31wCN","lot-number":"lot-number___2BLQ0"};